"use client";

import { Button } from "@/ui/components";
import { Logo } from "@/ui/components";
import { Menu, MoveRight, X } from '@/ui/icons'
import { useState } from "react";
import { Link } from "react-router-dom";

function Header1() {
    const navigationItems = [
        {
            title: "Home",
            href: "/",
        },
    ];

    const [isOpen, setOpen] = useState(false);
    return (
        <header className="w-full z-40 fixed top-0 left-0 bg-gray-50">
            <div className="container relative mx-auto min-h-20 flex gap-4 flex-row lg:grid lg:grid-cols-3 items-center">
                <div className="justify-start items-center gap-4 lg:flex hidden flex-row">
                    <nav className="flex justify-start items-start">
                        <ul className="flex justify-start gap-4 flex-row">
                            {navigationItems.map((item) => (
                                <li key={item.title}>
                                    <Button variant="ghost" asChild>
                                        <Link to={item.href}>{item.title}</Link>
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
                <div className="flex lg:justify-center">
                    <Logo to="/" size="md" />
                </div>
                <div className="flex justify-end w-full gap-4">
                    <Button variant="outline" asChild>
                        <Link to="/login">Sign in</Link>
                    </Button>
                    <Button asChild>
                        <Link to="/signup">Get started</Link>
                    </Button>
                </div>
                <div className="flex w-12 shrink lg:hidden items-end justify-end">
                    <Button variant="ghost" onClick={() => setOpen(!isOpen)}>
                        {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </Button>
                    {isOpen && (
                        <div className="absolute top-20 border-t flex flex-col w-full right-0 bg-gray-50 shadow-lg py-4 container gap-8">
                            {navigationItems.map((item) => (
                                <Link
                                    key={item.title}
                                    to={item.href}
                                    className="flex justify-between items-center"
                                    onClick={() => setOpen(false)}
                                >
                                    <span className="text-lg">{item.title}</span>
                                    <MoveRight className="w-4 h-4 stroke-1 text-muted-foreground" />
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}

export { Header1 };
